import { gql } from '@apollo/client';
import { ACTIVITY_FRAGMENT } from 'graphql/secure/fragments/activity.fragments';

export const GET_ACTIVITY = gql`
  query GetActivity($id: UUID!, $lang: Language) {
    activity(id: $id, lang: $lang) {
      ...activityValues
    }
  }
  ${ACTIVITY_FRAGMENT}
`;

export const GET_ACTIVITIES = gql`
  query GetActivities(
    $lang: Language
    $filters: ActivitiesFilters
    $first: Int
    $after: String
    $orderBy: ActivitiesOrderBy
  ) {
    activities(lang: $lang, filters: $filters, first: $first, after: $after, orderBy: $orderBy) {
      edges {
        node {
          ...activityValues
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${ACTIVITY_FRAGMENT}
`;
